<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      blank-header

    template(v-slot:default='props')
      bf-notice(@close='message = ""' :message='message')

      bf-dialog#rsv-dialog.positioned.no-header(
        :show='show.rsv'
        :scrolled='props.scrolled'
        @close='show.rsv = false'
      )
        add-order-dialog(
          :biz='biz'
          :account='account'
          :user='user'
          @notify='notify'
        )

      bf-wrapper#orders.view.content.no-header.content
        section#search(v-if="1==0")
          bf-input.icon-right.clear.thin
            input(
              type='search'
              :placeholder="$t('Search by date, name, service, etc...')"
            )
            template(v-slot:icon)
              search-icon

        section#buttons
          bf-flex.centered
            bf-button.new-promo.tertiary.icon-only( @click.native='show.rsv = true' )
              template( v-slot:icon )
                new-icon.icon2
                span.addorder {{$t("Add Order")}}
            bf-button.toggle-active.clear
              template( v-slot:text ) {{ $t('Next 7 Days') }}

            bf-button.toggle-inactive.tertiary.link
              template(v-slot:text)
                router-link( :to='{ name: "orders-weekly" }' ) {{ $t('Week/Month') }}

        //- section#month-select
        //-   bf-flex.month.centered
        //-     span.prev(@click='date = new Date( datetime.setDate( datetime.getDate() - 1 ) ).getDate()')
        //-       prev-icon
        //-     span.current {{ datetime.toDateString() }}
        //-     span.next(@click='date = new Date( datetime.setDate( datetime.getDate() + 1 ) ).getDate()')
        //-       next-icon

        section#service-orders.container
          template(v-if='!rsv')
            table(v-if='rsvs.length')
              thead
                tr
                  th {{ $t('Time') }}
                  th {{ $t('Customer') }}
                  th {{ $t('Details') }}
                  th {{ $t('Status') }}
              tbody
                tr(v-for='r in rsvs')
                  template(v-if='r.account')
                    td.time {{ r.datetime.start.toDate().toLocaleTimeString( [], { hour: '2-digit', minute: '2-digit' } ) }}
                    td {{ r.account.username }}
                    td(@click='view(r)')
                      a {{ r.service.title }}
                    td {{ $t(r.status || 'Confirmed') }}

            h5.centered-text(v-else='!rsvs.length') {{ $t('You have no appointments on this date') }}

          bf-overlay.solid.flush(
            v-else
            :user='user',
            :account='account',
            :biz='biz',
            :data='rsv',
            @close='rsv = false'
          )
            template(v-slot:heading)
              h5 {{ $t('Reservation/Appointment Details') }}

            #rsv-dtls.container
              rsv-dtls.overlay(
                v-if='rsv'
                :rsv='rsv'
              )
            rsv-msgs#rsv-msgs(
              v-if='rsv && account'
              :rsv='rsv'
              :account='account'
              :key='rsv.id'
            )
</template>

<script>
  import { View } from '@/mixins/view'
  import { Orders } from '@/mixins/viewable'

  export default {
    name: 'orders.view',

    mixins: [View, Orders],

    data() {
      return {
        rsv: false
      }
    },

    methods: {
      view( r ) {
        this.rsv = r
      },

      filter( r ) {
        let st = r.datetime.start.toDate()
        let week = new Date( this.datetime )
        week.setHours( 0, 0, 0 )
        week.setDate( week.getDate() + 8 )
        return  st >= this.datetime && st <= week
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .heading
    margin-bottom 32px

  #rsv-dialog
    background rgba(40 40 40 .8)
    padding 20px
    > .heading
      margin-bottom 20px
    .customers
      padding 1px
      overflow hidden
      .customer
        border-bottom 1px solid rgba( 0 0 0 .04 )
        border-top 1px solid rgba( 255 255 255 .5 )
        cursor pointer
        padding 12px 16px
        background rgba( 0 0 0 .04 )
        &.selected
          background rgba( 50 175 200 .75)
          color white
          border-bottom-color rgba( 0 0 0 .1 )
          border-top-color rgba( 255 255 255 1 )

        &:first-child
          border-top 0
          border-radius 12px 12px 0 0

        &:last-child
          border-radius 0 0 12px 12px

  #buttons
    margin 24px 0
    .bf-button
      margin-left 16px
      &:first-child
        margin-left 0
    .new-promo
      border 1px solid rgb(200 200 200)
    .toggle-inactive
      border 1px solid rgb(200 200 200)
      font-weight bold
      padding 3px 5px
    .toggle-active
      background white
      padding 10px 10px
    .icon2
      vertical-align middle
    .addorder
      font-size .48em
      vertical-align middle
      font-weight bold
      margin-left 5px
      
  #month-select
    .month
      font-weight bold
      color black
      text-align center
      .prev, .next
        vertical-align middle
        font-size 2.4em
      .current
        padding 0 12px

  #service-orders
    background white
    padding 10px
    margin-top 8px
    height auto
    border 1px solid rgb(200 200 200)
    border-radius 5px
    table
      border-radius 8px
      text-align left
      width 100%
      thead
        font-weight bold
      tbody tr:nth-child(odd)
        background rgba( 0 0 0 .04 )
      th, td
        padding 6px 8px
        text-align center
        a
          border-bottom 1px dotted
        &:first-child
          text-align left
        &:last-child
          text-align right
      td:nth-child(2),
      td:nth-child(3)
        color rgb( 0 200 255 )
      td.time
        font-family monospace
        font-size 1.25em

  #rsv-dtls.container
    margin 16px
  #rsv-msgs
    padding 8px
</style>
